import { Modal, Form, Input, Select, Switch, message } from "antd";
import { useEffect } from "react";
import axios from "axios";

const { Option } = Select;

export default function UserEditModal({ visible, onCancel, user, onUpdateSuccess }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      console.log("User object received in UserEditModal:", user);
      form.setFieldsValue({
        ...user,
        activo: user.activo === 1, // Convert tinyint to boolean for Switch
      });
      console.log("Form fields after setFieldsValue:", form.getFieldsValue());
    }
  }, [user, form]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      const updatedUser = {
        ...values,
        activo: values.activo ? 1 : 0, // Convert boolean back to tinyint
      };

      axios
        .put(`${process.env.REACT_APP_API_URL}/usuarios/${user.email}`, updatedUser)
        .then(() => {
          message.success("Usuario actualizado correctamente");
          onUpdateSuccess();
          onCancel();
        })
        .catch((err) => {
          message.error("Error al actualizar usuario: " + err.message);
        });
    });
  };

  return (
    <Modal visible={visible} title="Editar Usuario" okText="Guardar" cancelText="Cancelar" onCancel={onCancel} onOk={handleOk}>
      <Form form={form} layout="vertical" name="user_edit_form">
        <Form.Item name="email" label="Email" rules={[{ required: true, message: "Por favor ingrese el email" }]}>
          <Input disabled/>
        </Form.Item>
        <Form.Item name="password" label="Contraseña">
          <Input.Password />
        </Form.Item>
        <Form.Item name="nombre" label="Nombre" rules={[{ required: true, message: "Por favor ingrese el nombre" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="apellido" label="Apellido" rules={[{ required: true, message: "Por favor ingrese el apellido" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="UvieID" label="Uvie ID" rules={[{ required: true, message: "Por favor ingrese el Uvie ID" }]}>
          <Input type="number" />
        </Form.Item>
        <Form.Item name="rol" label="Rol" rules={[{ required: true, message: "Por favor seleccione el rol" }]}>
          <Select>
            {/* <Option value="admin">Admin</Option> */}
            <Option value="director">director</Option>
            <Option value="usuario">usuario</Option>
          </Select>
        </Form.Item>
        <Form.Item name="activo" label="Activo" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
}
